import { Component, Host, h, Element, State } from '@stencil/core';

export interface AhaModalBody extends HTMLAhaModalBodyElement {}

/**
 * Modal body container meant to be used in conjunction with `aha-modal-header` and `aha-modal-footer`
 * @slot Default - Contents of `aha-modal-body`
 */
@Component({
  tag: 'aha-modal-body',
  styleUrl: 'aha-modal-body.css',
  shadow: true,
})
export class AhaModalBody {
  @Element() hostElement!: HTMLAhaModalBodyElement;

  /**
   * Used to adjust styling of the left/right content panes.
   */
  @State() hasLeftContent: boolean = false;
  @State() hasRightContent: boolean = false;

  connectedCallback() {
    if (!this.hostElement.slot && this.hostElement.parentElement?.tagName === 'AHA-MODAL') {
      this.hostElement.slot = 'modal-body';
    }
  }

  leftSlotChanged = (event: Event) => {
    this.hasLeftContent = (event.target as HTMLSlotElement).assignedNodes().length > 0;
  };

  rightSlotChanged = (event: Event) => {
    this.hasRightContent = (event.target as HTMLSlotElement).assignedNodes().length > 0;
  };

  render() {
    return (
      <Host has-left-content={this.hasLeftContent} has-right-content={this.hasRightContent}>
        <slot name="left-content" onSlotchange={this.leftSlotChanged}></slot>

        {/* @ts-ignore yes it does have an ID */}
        <slot id="content"></slot>

        <slot name="right-content" onSlotchange={this.rightSlotChanged}></slot>
      </Host>
    );
  }
}
